module.exports = __webpack_public_path__ + "img/Profil_CS-Slimlineri_Medium.54dd5102.jpg";